// Based on value from the material template (which in turn based on Blender 2.83), this changed in Cycles 4.2 to 1.5
export const defaults = {
    ior: 1.45,
    specular: 0.5,
    baseColor: {r: 0.8, g: 0.8, b: 0.8},
    specularTint: 0.0,
}
